/**
 * Hook chamado UMA vez pelo app-core (`ui/modules.tsx`): liga o carregamento
 * das estações e adiciona a camada ao mapa quando ele existir.
 */
import { createElement, useEffect } from 'react';
import { useMapInstance } from '../map/mapContext';
import { createMeteoLayer } from './layer';
import { MeteoPopup } from './MeteoPopup';
import { iniciarSyncMeteo } from './sync';

export { refreshMeteo } from './sync';

export function useMeteoLayers(): void {
  const map = useMapInstance((s) => s.map);

  useEffect(() => iniciarSyncMeteo(), []);

  useEffect(() => {
    if (!map) return;
    const { layer, dispose } = createMeteoLayer((dado) => createElement(MeteoPopup, { dado }));
    map.addLayer(layer);
    return () => {
      map.removeLayer(layer);
      dispose();
    };
  }, [map]);
}
